import clsx from "clsx";
import { useCallback } from "react";
import { useChatContext } from "stream-chat-react";

import DirectMessagingChannelPreview from "./DirectMessagingChannelPreview";
import TeamChannelPreview from "./TeamChannelPreview";

import { useWorkspaceController } from "../../context/WorkspaceController";

export default function ChannelPreview({ channel, type }) {
  const { channel: activeChannel, setActiveChannel } = useChatContext();
  const { displayWorkspace } = useWorkspaceController();

  const handleClick = useCallback(() => {
    displayWorkspace("Chat");
    if (setActiveChannel) {
      setActiveChannel(channel);
    }
  }, [channel, displayWorkspace, setActiveChannel]);

  return (
    <button
      className={clsx("channel-preview", { selected: channel?.id === activeChannel?.id })}
      onClick={handleClick}
      type="button"
    >
      {type === "team" ? (
        <TeamChannelPreview channel={channel} />
      ) : (
        <DirectMessagingChannelPreview channel={channel} />
      )}
    </button>
  );
}
